import * as React from 'react';
import './Loading.css';


interface LoadingIndicatorProps {
    showBackground?: boolean;
}

export class LoadingIndicatorMini extends React.Component<LoadingIndicatorProps> {
    render() {
        return <div className={`badge-loading-container mini ${this.props.showBackground ? 'with-background' : ''}`}>
            <div className={`loading-badge-container animating`}>
                <img className="spinner-icon" src="/images/Loading_spinner.svg" />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/loadingIndicator/LoadingIndicatorMini.tsx